/* Charliee article
 * Builds the table of contents from the H2s in the rendered body, tracks reading
 * progress, and highlights the current section. Done client-side so editors
 * never have to hand-maintain a contents list.
 */
(function () {
  var prose = document.querySelector('[data-ca-prose]');
  var tocList = document.querySelector('[data-ca-toc]');
  var bar = document.querySelector('[data-ca-progress]');
  if (!prose) return;

  /* ---------- build the contents list ---------- */
  var heads = [];
  if (tocList) {
    var nodes = prose.querySelectorAll('h2');
    for (var i = 0; i < nodes.length; i++) {
      var h = nodes[i];
      if (!h.id) {
        h.id = 'section-' + (i + 1) + '-' + (h.textContent || '')
          .toLowerCase().trim()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .slice(0, 40);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      tocList.appendChild(li);
      heads.push({ el: h, link: a });
    }
    if (!heads.length) {
      var rail = document.querySelector('[data-ca-rail]');
      if (rail) rail.style.display = 'none';
    }
  }

  /* ---------- progress + current section ---------- */
  var ticking = false;
  function update() {
    ticking = false;

    if (bar) {
      var box = prose.getBoundingClientRect();
      var total = box.height - window.innerHeight;
      var done = total > 0 ? (-box.top) / total : 0;
      bar.style.width = Math.max(0, Math.min(1, done)) * 100 + '%';
    }

    if (heads.length) {
      var current = heads[0];
      for (var i = 0; i < heads.length; i++) {
        if (heads[i].el.getBoundingClientRect().top <= 120) current = heads[i];
      }
      for (var j = 0; j < heads.length; j++) {
        heads[j].link.classList.toggle('is-current', heads[j] === current);
      }
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();

  /* ---------- copy link ---------- */
  var copy = document.querySelector('[data-ca-copy]');
  if (copy && navigator.clipboard) {
    copy.addEventListener('click', function () {
      navigator.clipboard.writeText(window.location.href).then(function () {
        var was = copy.getAttribute('aria-label');
        copy.setAttribute('aria-label', 'Link copied');
        setTimeout(function () { copy.setAttribute('aria-label', was); }, 1600);
      });
    });
  }
})();
